import axios from "axios";
import interceptors from "./interceptors";

export const http = axios.create({
  baseURL: "/ajax",
  headers: {
    common: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "multipart/form-data",
    },
  },
});

export default function install(Vue, { store, router }) {
  interceptors(http, store, router);
  Object.defineProperty(Vue.prototype, "$http", {
    get() {
      return http;
    },
  });
}
